import { AUTOMATION_LATEST_VERSION_KEY } from '@/utils/queryKeys.ts';
import { get_automation_latest_version_url } from '@/utils/urls.ts';
import { useQuery } from '@tanstack/react-query';
import useAutomationId from '@/hooks/useAutomationId.ts';

import { useApiClient } from '@/context/ApiClientContext/useApiClient.ts';
import { AutomationVersion } from '@/types/automations.ts';

const useRetrieveLatestAutomationVersion = () => {
  const apiClient = useApiClient();
  const automationId = useAutomationId();
  const queryKey = AUTOMATION_LATEST_VERSION_KEY(automationId);

  return useQuery<AutomationVersion, Error>({
    queryKey: queryKey,
    queryFn: async () => {
      const response = await apiClient.get(get_automation_latest_version_url(automationId));
      return response.data;
    },
    enabled: !!automationId,
  });
};

export default useRetrieveLatestAutomationVersion;
